import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import ErrorPage from "./Error";
import Home from "./Home";
import AboutUs from "./AboutUs";
import Scores from "./Scores";
import Standings from "./Standings";
import Calendar from "./Calendar";
import Locations from "./Locations";
import Policies from "./Policies";
import History from "./History";
import PastResults from "./PastResults";
import Modified from "./Modified";

const router = createBrowserRouter([
    {
        path: "/",
        element: <App/>,
        errorElement: <ErrorPage/>,
        children: [
            {
                index: true,
                element: <Home/>
            },
            {
                path: "standings",
                element: <Standings/>
            },
            {
                path: "policies",
                element: <Policies/>
            },
            {
                path: "locations",
                element: <Locations/>
            },
            {
                path: "pastResults",
                element: <PastResults/>
            },
            {
                path: "aboutUs",
                element: <AboutUs/>
            },
            {
                path: "modified",
                element: <Modified/>
            }
        ]
    }
]);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
      <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
